import { app } from '../../app.module'
app
  // イベント画面の投稿一覧モーダル
  .directive('eventPostListModal', () => {
    return {
      restrict: 'A',
      controller: ($scope, $mdDialog, $rootScope) => {
        // イベント投稿一覧の場合は、アカウント名をクリックできないようにする。
        // また、イベント投稿一覧フラグをOnにする。
        $scope.showAccountDetailModalFlg = false
        $scope.eventModalFlag = true

        /**
         * ディレクティブが読み込まれた際に、SNSの利用許可ごとに、
         * 初回表示するSNSを決める
         */
        $scope.selectInitSns = function () {
          if ($rootScope.flgFacebook === true) {
            $scope.snsType = 'facebook'
            return
          }
          if ($rootScope.flgTwitter === true) {
            $scope.snsType = 'twitter'
            return
          }
          if ($rootScope.flgInstagram === true) {
            $scope.snsType = 'instagram'
            return
          }
          if ($rootScope.flgYoutube === true) {
            $scope.snsType = 'youtube'
            return
          }
          if ($rootScope.flgLine === true) {
            $scope.snsType = 'line'
            return
          }
        }

        /**
         * タブが選択された際の処理
         * @param {string} selectedSns 選択されたSNS
         */
        $scope.selectTab = function (selectedSns: string) {
          $scope.snsType = selectedSns
        }

        /**
         * SNSタイプを変更するイベント
         */
        $scope.$watch(
          () => {
            return $scope.snsType
          },
          () => {
            if ($scope.snsType === 'youtube') {
              $scope.getOptions.order = 'views'
            } else {
              $scope.getOptions.order = 'engagements'
            }
          }
        )

        /**
         * モーダルを閉じる処理
         */
        $scope.close = function () {
          $mdDialog.hide()
        }
      },
    }
  })
